module.exports = {
    GET: 'GET',
    POST: 'POST',
    DEV: 'https://api.dev.openbank.es',
    QA: 'https://api.qa.openbank.es',
    SPAIN:'ES',
    CARD: 'Card',
    TRANFER: 'Transfer',
    STAGING: 'https://api.stg.openbank.es',
    OCULTO: 'https://api.ocu.openbank.es',
    LOCAL: 'https://127.0.0.1:13000',
    PROD: 'https://api.openbank.es',
    DEV_HOST: 'DEV',
    QA_HOST: 'QA',
    STAGING_HOST: 'STAGING',
    OCULTO_HOST: 'OCULTO',
    LOCAL_HOST: 'LOCAL',
    PROD_HOST: 'PRODUCCION',
    STAGING_ASSETS_URL: 'https://www.stg.openbank.es',
    QA_ASSETS_URL: 'https://www.qa.openbank.es',
    OCULTO_ASSETS_URL: 'https://www.ocu.openbank.es',
    DEV_ASSETS_URL: 'https://www.dev.openbank.es',
    PROD_ASSETS_URL: 'https://www.openbank.es',
    API_DETAIL_URL: '/campaigns-engine/contrataciones/private/default/',
    STAGINGCC: 'https://apiccstgalb001.aws.ok-cloud.net',
    OCUCC: 'apiocucch001.aws.openbank.corp',
    PRODCC: 'apiprocch001.aws.openbank.corp',
    QACC: 'https://apiccqaalb001.aws.ok-cloud.net',
    DEVCC: 'https://apiccdevalb001.aws.ok-cloud.net',
  };